// socket.js

import socketIOClient from 'socket.io-client';

const socket = socketIOClient(process.env.REACT_APP_GLOBAL_DIAL_NODE_SERVER);

export default socket;